// import React, { useState, useEffect } from 'react';
// import {
//   Globe, Smartphone, Cloud, TestTube, BarChart3,
//   Code, Layout, ShoppingCart, Database, Server,
//   Cpu, Shield, Monitor, Zap, Brain, Eye,
//   GitBranch, Lock, TrendingUp, Settings,
//   FileText, ChevronRight, Star, ArrowRight
// } from 'lucide-react';

// const ServicesComponent = () => {
//   const [activeCategory, setActiveCategory] = useState(0);
//   const [hoveredService, setHoveredService] = useState(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     setIsVisible(true);
//   }, []);

//   const serviceCategories = [
//     {
//       id: 1,
//       title: "Web Application Development",
//       icon: <Globe className="w-6 h-6" />,
//       color: "#4f46e5",
//       gradient: "from-indigo-500 to-blue-600",
//       bgGradient: "from-indigo-50 to-blue-50",
//       services: [
//         {
//           title: "Custom Website Design & Development",
//           description: "Responsive, mobile-first layouts with UX/UI design tailored to your brand",
//           icon: <Layout className="w-6 h-6" />,
//           features: ["Responsive Design", "Mobile-First", "Brand Integration", "CMS Integration"],
//           color: "#4f46e5"
//         },
//         {
//           title: "Single-Page Applications (SPA)",
//           description: "React.js, Vue.js or Angular frameworks with client-side routing & state management",
//           icon: <Code className="w-6 h-6" />,
//           features: ["React/Vue/Angular", "State Management", "PWA Support", "Offline Functionality"],
//           color: "#7c3aed"
//         },
//         {
//           title: "Enterprise Web Portals",
//           description: "Role-based access control with multi-tenant architectures and ERP/CRM integration",
//           icon: <Server className="w-6 h-6" />,
//           features: ["Role-based Access", "Multi-tenant", "ERP Integration", "High Availability"],
//           color: "#2563eb"
//         },
//         {
//           title: "eCommerce Solutions",
//           description: "Shopify, WooCommerce, Magento setups with custom shopping cart & payment integration",
//           icon: <ShoppingCart className="w-6 h-6" />,
//           features: ["Multiple Platforms", "Payment Gateway", "Inventory Management", "Analytics"],
//           color: "#dc2626"
//         },
//         {
//           title: "API Design & Development",
//           description: "RESTful and GraphQL API design with OAuth2/JWT authentication and documentation",
//           icon: <Database className="w-6 h-6" />,
//           features: ["REST & GraphQL", "Authentication", "Rate Limiting", "Documentation"],
//           color: "#059669"
//         }
//       ]
//     },
//     {
//       id: 2,
//       title: "Mobile Application Development",
//       icon: <Smartphone className="w-6 h-6" />,
//       color: "#10b981",
//       gradient: "from-emerald-500 to-teal-600",
//       bgGradient: "from-emerald-50 to-teal-50",
//       services: [
//         {
//           title: "iOS App Development",
//           description: "Swift and Objective-C expertise with native UI components & Apple services integration",
//           icon: <Smartphone className="w-6 h-6" />,
//           features: ["Swift/Objective-C", "Native UI", "Apple Services", "App Store Ready"],
//           color: "#374151"
//         },
//         {
//           title: "Android App Development",
//           description: "Kotlin and Java expertise with Material Design and Google Play Store publishing",
//           icon: <Monitor className="w-6 h-6" />,
//           features: ["Kotlin/Java", "Material Design", "Background Processing", "Play Store"],
//           color: "#16a34a"
//         },
//         {
//           title: "Cross-Platform Apps",
//           description: "React Native, Flutter, or Xamarin with shared codebase and native-like performance",
//           icon: <Cpu className="w-6 h-6" />,
//           features: ["React Native/Flutter", "Shared Codebase", "Native Performance", "OTA Updates"],
//           color: "#0891b2"
//         },
//         {
//           title: "Hybrid Mobile Apps",
//           description: "Ionic or Cordova frameworks for rapid prototyping and cost-effective MVP development",
//           icon: <Zap className="w-6 h-6" />,
//           features: ["Ionic/Cordova", "Rapid Prototyping", "Native Features", "Cost-effective"],
//           color: "#7c2d12"
//         },
//         {
//           title: "Mobile App Maintenance & Support",
//           description: "Bug fixes, OS compatibility updates, performance optimization and crash analytics",
//           icon: <Settings className="w-6 h-6" />,
//           features: ["Bug Fixes", "OS Updates", "Performance", "Analytics"],
//           color: "#be123c"
//         }
//       ]
//     },
//     {
//       id: 3,
//       title: "DevOps & Cloud Services",
//       icon: <Cloud className="w-6 h-6" />,
//       color: "#f59e0b",
//       gradient: "from-amber-500 to-orange-600",
//       bgGradient: "from-amber-50 to-orange-50",
//       services: [
//         {
//           title: "CI/CD Pipeline Implementation",
//           description: "Jenkins, GitLab CI, GitHub Actions with automated build, test, and deployment workflows",
//           icon: <GitBranch className="w-6 h-6" />,
//           features: ["Jenkins/GitLab CI", "Automated Workflows", "Docker Containers", "IaC"],
//           color: "#ea580c"
//         },
//         {
//           title: "Cloud Architecture & Migration",
//           description: "AWS, Azure, GCP solution design with lift-and-shift or refactor migrations",
//           icon: <Cloud className="w-6 h-6" />,
//           features: ["AWS/Azure/GCP", "Migration Strategy", "Cost Optimization", "Auto-scaling"],
//           color: "#0369a1"
//         },
//         {
//           title: "Containerization & Orchestration",
//           description: "Docker containerization with Kubernetes cluster setup, management and Helm charts",
//           icon: <Server className="w-6 h-6" />,
//           features: ["Docker", "Kubernetes", "Helm Charts", "Best Practices"],
//           color: "#7c3aed"
//         },
//         {
//           title: "Monitoring & Logging",
//           description: "Prometheus, Grafana dashboards with ELK/EFK logging stacks and alerting integration",
//           icon: <BarChart3 className="w-6 h-6" />,
//           features: ["Prometheus/Grafana", "ELK Stack", "Alerting", "Dashboards"],
//           color: "#dc2626"
//         },
//         {
//           title: "Security & Compliance",
//           description: "Vulnerability scanning, secrets management and GDPR, HIPAA, SOC-2 advisory",
//           icon: <Shield className="w-6 h-6" />,
//           features: ["Vulnerability Scanning", "Secrets Management", "Compliance", "Security Advisory"],
//           color: "#059669"
//         }
//       ]
//     },
//     {
//       id: 4,
//       title: "Quality Assurance & Testing",
//       icon: <TestTube className="w-6 h-6" />,
//       color: "#ef4444",
//       gradient: "from-red-500 to-pink-600",
//       bgGradient: "from-red-50 to-pink-50",
//       services: [
//         {
//           title: "Manual Testing Services",
//           description: "Functional, regression, smoke testing with usability & exploratory testing expertise",
//           icon: <Eye className="w-6 h-6" />,
//           features: ["Functional Testing", "Regression Testing", "Usability Testing", "Test Design"],
//           color: "#dc2626"
//         },
//         {
//           title: "Automated Testing Frameworks",
//           description: "Selenium WebDriver, Cypress, Playwright with API and mobile testing capabilities",
//           icon: <Cpu className="w-6 h-6" />,
//           features: ["Selenium/Cypress", "API Testing", "Mobile Testing", "Automated Frameworks"],
//           color: "#7c3aed"
//         },
//         {
//           title: "Performance & Load Testing",
//           description: "JMeter, Gatling load scripts with stress testing and bottleneck analysis",
//           icon: <TrendingUp className="w-6 h-6" />,
//           features: ["JMeter/Gatling", "Load Testing", "Stress Testing", "Performance Analysis"],
//           color: "#ea580c"
//         },
//         {
//           title: "Security Testing (Penetration Testing)",
//           description: "OWASP Top 10 assessment with network & application layer penetration tests",
//           icon: <Shield className="w-6 h-6" />,
//           features: ["OWASP Assessment", "Penetration Testing", "Security Analysis", "Remediation"],
//           color: "#059669"
//         },
//         {
//           title: "Test Management & Reporting",
//           description: "TestRail, Zephyr setup with detailed QA dashboards and defect tracking workflows",
//           icon: <FileText className="w-6 h-6" />,
//           features: ["Test Management", "QA Dashboards", "Defect Tracking", "Reporting"],
//           color: "#0891b2"
//         }
//       ]
//     },
//     {
//       id: 5,
//       title: "Data Science & Analytics",
//       icon: <BarChart3 className="w-6 h-6" />,
//       color: "#8b5cf6",
//       gradient: "from-violet-500 to-purple-600",
//       bgGradient: "from-violet-50 to-purple-50",
//       services: [
//         {
//           title: "Data Strategy & Consulting",
//           description: "Data maturity assessment with roadmap for data governance & technology stack recommendation",
//           icon: <TrendingUp className="w-6 h-6" />,
//           features: ["Maturity Assessment", "Data Governance", "Technology Stack", "Strategic Roadmap"],
//           color: "#7c3aed"
//         },
//         {
//           title: "Data Engineering & ETL",
//           description: "Batch & real-time pipelines with data lake & warehouse design and API-driven ingestion",
//           icon: <Database className="w-6 h-6" />,
//           features: ["Airflow/Kafka", "Data Warehouse", "Real-time Pipelines", "API Integration"],
//           color: "#0369a1"
//         },
//         {
//           title: "Machine Learning & AI Solutions",
//           description: "Predictive modeling, NLP solutions, and computer vision pipelines with latest frameworks",
//           icon: <Brain className="w-6 h-6" />,
//           features: ["ML Models", "NLP Solutions", "Computer Vision", "TensorFlow/PyTorch"],
//           color: "#dc2626"
//         },
//         {
//           title: "Business Intelligence & Reporting",
//           description: "Dashboards with Power BI, Looker, Tableau and KPI definition with self-service analytics",
//           icon: <BarChart3 className="w-6 h-6" />,
//           features: ["Power BI/Tableau", "KPI Tracking", "Self-service Analytics", "Custom Dashboards"],
//           color: "#ea580c"
//         },
//         {
//           title: "MLOps & Model Deployment",
//           description: "Model versioning & monitoring with containerized serving and data drift alerts",
//           icon: <Settings className="w-6 h-6" />,
//           features: ["MLflow/Seldon", "Model Monitoring", "Container Deployment", "Performance Alerts"],
//           color: "#059669"
//         }
//       ]
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-16 px-4">
//       <div className="max-w-7xl mx-auto">
//         {/* Header Section */}
//         <div className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//           <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full mb-6">
//             <Star className="w-8 h-8 text-white" />
//           </div>
//           <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
//             Our <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">Services</span>
//           </h1>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
//             Comprehensive software development solutions tailored to drive innovation and accelerate your digital transformation journey.
//           </p>
//         </div>

//         {/* Category Navigation */}
       
//                <div className="flex justify-center px-4">
//               <div className="flex space-x-5 bg-white/80 backdrop-blur-sm rounded-2xl p-4  border border-white/20">
//                 {serviceCategories.map((category, index) => (
//                   <button
//                     key={category.id}
//                     onClick={() => setActiveCategory(index)}
//                     className={`relative flex items-center px-6 py-4 rounded-xl font-semibold transition-all duration-500 transform hover:scale-105 group ${
//                       activeCategory === index
//                         ? 'text-white shadow-2xl scale-105'
//                         : 'text-gray-700 hover:text-gray-900 hover:bg-white/50'
//                     }`}
//                     style={{
//                       background: activeCategory === index
//                         ? `linear-gradient(135deg, ${category.color}, ${category.color}dd)`
//                         : 'transparent'
//                     }}
//                   >
//                     {/* Animated Background for Active Tab */}
//                     {activeCategory === index && (
//                       <div
//                         className="absolute inset-0 rounded-xl opacity-30 animate-pulse"
//                         style={{ background: `linear-gradient(135deg, ${category.color}, ${category.color}44)` }}
//                       />
//                     )}
                    
//                     {/* Icon/Image Container */}
//                     <div className="relative mr-3 overflow-hidden rounded-lg">
//                       {category.image ? (
//                         <img
//                           src={category.image}
//                           alt={category.title}
//                           className={`w-8 h-8 object-cover transition-all duration-500 ${
//                             activeCategory === index ? 'scale-110 brightness-110' : 'scale-100'
//                           }`}
//                         />
//                       ) : (
//                         <div className={`transition-all duration-500 ${activeCategory === index ? 'scale-110 rotate-6' : 'scale-100'}`}>
//                           {category.icon}
//                         </div>
//                       )}
//                     </div>
                    
//                     <span className="relative z-10 text-sm lg:text-base">{category.title}</span>
                    
//                     {/* Floating Particles for Active Tab */}
//                     {activeCategory === index && (
//                       <div className="absolute inset-0 pointer-events-none">
//                         {[...Array(3)].map((_, i) => (
//                           <div
//                             key={i}
//                             className="absolute w-1 h-1 rounded-full animate-ping"
//                             style={{
//                               backgroundColor: '#ffffff',
//                               top: `${20 + i * 20}%`,
//                               right: `${10 + i * 15}%`,
//                               animationDelay: `${i * 200}ms`,
//                               animationDuration: '2s'
//                             }}
//                           />
//                         ))}
//                       </div>
//                     )}
//                   </button>
//                 ))}
//               </div>
//             </div>

//         {/* Active Category Content */}
//         <div className="mb-16">
//           {serviceCategories.map((category, categoryIndex) => (
//             <div
//               key={category.id}
//               className={`transition-all duration-700 ${
//                 activeCategory === categoryIndex
//                   ? 'opacity-100 translate-y-0'
//                   : 'opacity-0 translate-y-10 absolute pointer-events-none'
//               }`}
//             >
//               {activeCategory === categoryIndex && (
//                 <>
//                   {/* Category Header */}
//                   <div className="text-center mb-12">
//                     <div
//                       className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-6 shadow-lg"
//                       style={{ backgroundColor: `${category.color}15`, color: category.color }}
//                     >
//                       <div className="scale-150">{category.icon}</div>
//                     </div>
//                     <h2 className="text-4xl font-bold text-gray-900 mb-4">{category.title}</h2>
//                     <div className="w-24 h-1 rounded-full mx-auto" style={{ backgroundColor: category.color }}></div>
//                   </div>

//                   {/* Services Grid */}
//                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                     {category.services.map((service, serviceIndex) => (
//                       <div
//                         key={serviceIndex}
//                         className={`group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100 overflow-hidden ${
//                           isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
//                         }`}
//                         style={{ transitionDelay: `${serviceIndex * 100}ms` }}
//                         onMouseEnter={() => setHoveredService(`${categoryIndex}-${serviceIndex}`)}
//                         onMouseLeave={() => setHoveredService(null)}
//                       >
//                         {/* Animated Background */}
//                         <div
//                           className={`absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500 bg-gradient-to-br`}
//                           style={{ background: `linear-gradient(135deg, ${service.color}22, ${service.color}11)` }}
//                         ></div>
                        
//                         {/* Glowing Border */}
//                         <div
//                           className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"
//                           style={{ boxShadow: `0 0 30px ${service.color}25` }}
//                         ></div>

//                         {/* Content */}
//                         <div className="relative z-10">
//                           {/* Service Icon */}
//                           <div
//                             className="inline-flex items-center justify-center w-14 h-14 rounded-xl mb-6 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3"
//                             style={{ backgroundColor: `${service.color}15`, color: service.color }}
//                           >
//                             {service.icon}
//                           </div>

//                           {/* Service Title */}
//                           <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-gray-900 group-hover:to-gray-700 group-hover:bg-clip-text transition-all duration-300">
//                             {service.title}
//                           </h3>

//                           {/* Service Description */}
//                           <p className="text-gray-600 text-sm mb-6 leading-relaxed">
//                             {service.description}
//                           </p>

//                           {/* Features */}
//                           <div className="space-y-2 mb-6">
//                             {service.features.map((feature, featureIndex) => (
//                               <div
//                                 key={featureIndex}
//                                 className={`flex items-center text-xs text-gray-500 transition-all duration-500 ${
//                                   hoveredService === `${categoryIndex}-${serviceIndex}` ? 'text-gray-700 translate-x-2' : ''
//                                 }`}
//                                 style={{ transitionDelay: `${featureIndex * 50}ms` }}
//                               >
//                                 <div
//                                   className="w-1.5 h-1.5 rounded-full mr-3 transition-all duration-300"
//                                   style={{
//                                     backgroundColor: hoveredService === `${categoryIndex}-${serviceIndex}` ? service.color : '#9ca3af'
//                                   }}
//                                 ></div>
//                                 {feature}
//                               </div>
//                             ))}
//                           </div>

//                           {/* Learn More Button */}
//                           <div className={`transition-all duration-500 ${
//                             hoveredService === `${categoryIndex}-${serviceIndex}` ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
//                           }`}>
//                             <button
//                               className="flex items-center justify-between w-full py-3 px-4 rounded-lg text-white text-sm font-medium transition-all duration-300 hover:shadow-lg group"
//                               style={{ backgroundColor: service.color }}
//                             >
//                               <span>Learn More</span>
//                               <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
//                             </button>
//                           </div>
//                         </div>

//                         {/* Floating Elements */}
//                         {hoveredService === `${categoryIndex}-${serviceIndex}` && (
//                           <div className="absolute inset-0 pointer-events-none overflow-hidden">
//                             {[...Array(4)].map((_, i) => (
//                               <div
//                                 key={i}
//                                 className="absolute w-2 h-2 rounded-full animate-ping"
//                                 style={{
//                                   backgroundColor: service.color,
//                                   top: `${15 + i * 20}%`,
//                                   right: `${5 + i * 10}%`,
//                                   animationDelay: `${i * 300}ms`,
//                                   animationDuration: '3s',
//                                   opacity: 0.6
//                                 }}
//                               ></div>
//                             ))}
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 </>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Call to Action */}
//         <div className={`text-center bg-gradient-to-r from-indigo-500 to-purple-600 rounded-3xl p-12 text-white transition-all duration-1000 delay-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//           <h2 className="text-4xl font-bold mb-6">Ready to Start Your Project?</h2>
//           <p className="text-xl text-indigo-100 mb-8 max-w-2xl mx-auto">
//             Let's collaborate to bring your vision to life with cutting-edge technology and expert development.
//           </p>
//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <button className="px-8 py-4 bg-white text-indigo-600 font-semibold rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300">
//               Get Free Consultation
//             </button>
//             <button className="px-8 py-4 border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-indigo-600 transition-all duration-300">
//               View Our Portfolio
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServicesComponent;


import React, { useState, useEffect } from 'react';
import { 
  Globe, Smartphone, Cloud, TestTube, BarChart3, 
  Code, Layout, ShoppingCart, Database, Server,
  Cpu, Shield, Monitor, Zap, Brain, Eye,
  GitBranch, Lock, TrendingUp, Settings,
  FileText, ChevronRight, Star, ArrowRight
} from 'lucide-react';

const ServicesComponent = () => {
  const [activeCategory, setActiveCategory] = useState(0);
  const [hoveredService, setHoveredService] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const serviceCategories = [
    {
      id: 1,
      title: "Web Development",
      shortTitle: "Web Dev",
      icon: <Globe className="w-5 h-5" />,
      color: "#4f46e5",
      gradient: "from-indigo-500 to-blue-600",
      bgGradient: "from-indigo-50 to-blue-50",
      services: [
        {
          title: "Custom Website Design & Development",
          description: "Responsive, mobile-first layouts with UX/UI design tailored to your brand",
          icon: <Layout className="w-6 h-6" />,
          features: ["Responsive Design", "Mobile-First", "Brand Integration", "CMS Integration"],
          color: "#4f46e5"
        },
        {
          title: "Single-Page Applications (SPA)",
          description: "React.js, Vue.js or Angular frameworks with client-side routing & state management",
          icon: <Code className="w-6 h-6" />,
          features: ["React/Vue/Angular", "State Management", "PWA Support", "Offline Functionality"],
          color: "#7c3aed"
        },
        {
          title: "Enterprise Web Portals",
          description: "Role-based access control with multi-tenant architectures and ERP/CRM integration",
          icon: <Server className="w-6 h-6" />,
          features: ["Role-based Access", "Multi-tenant", "ERP Integration", "High Availability"],
          color: "#2563eb"
        },
        {
          title: "eCommerce Solutions",
          description: "Shopify, WooCommerce, Magento setups with custom shopping cart & payment integration",
          icon: <ShoppingCart className="w-6 h-6" />,
          features: ["Multiple Platforms", "Payment Gateway", "Inventory Management", "Analytics"],
          color: "#dc2626"
        },
        {
          title: "API Design & Development",
          description: "RESTful and GraphQL API design with OAuth2/JWT authentication and documentation",
          icon: <Database className="w-6 h-6" />,
          features: ["REST & GraphQL", "Authentication", "Rate Limiting", "Documentation"],
          color: "#059669"
        }
      ]
    },
    {
      id: 2,
      title: "Mobile Development",
      shortTitle: "Mobile",
      icon: <Smartphone className="w-5 h-5" />,
      color: "#10b981",
      gradient: "from-emerald-500 to-teal-600",
      bgGradient: "from-emerald-50 to-teal-50",
      services: [
        {
          title: "iOS App Development",
          description: "Swift and Objective-C expertise with native UI components & Apple services integration",
          icon: <Smartphone className="w-6 h-6" />,
          features: ["Swift/Objective-C", "Native UI", "Apple Services", "App Store Ready"],
          color: "#374151"
        },
        {
          title: "Android App Development",
          description: "Kotlin and Java expertise with Material Design and Google Play Store publishing",
          icon: <Monitor className="w-6 h-6" />,
          features: ["Kotlin/Java", "Material Design", "Background Processing", "Play Store"],
          color: "#16a34a"
        },
        {
          title: "Cross-Platform Apps",
          description: "React Native, Flutter, or Xamarin with shared codebase and native-like performance",
          icon: <Cpu className="w-6 h-6" />,
          features: ["React Native/Flutter", "Shared Codebase", "Native Performance", "OTA Updates"],
          color: "#0891b2"
        },
        {
          title: "Hybrid Mobile Apps",
          description: "Ionic or Cordova frameworks for rapid prototyping and cost-effective MVP development",
          icon: <Zap className="w-6 h-6" />,
          features: ["Ionic/Cordova", "Rapid Prototyping", "Native Features", "Cost-effective"],
          color: "#7c2d12"
        },
        {
          title: "Mobile App Maintenance & Support",
          description: "Bug fixes, OS compatibility updates, performance optimization and crash analytics",
          icon: <Settings className="w-6 h-6" />,
          features: ["Bug Fixes", "OS Updates", "Performance", "Analytics"],
          color: "#be123c"
        }
      ]
    },
    {
      id: 3,
      title: "DevOps & Cloud",
      shortTitle: "DevOps",
      icon: <Cloud className="w-5 h-5" />,
      color: "#f59e0b",
      gradient: "from-amber-500 to-orange-600",
      bgGradient: "from-amber-50 to-orange-50",
      services: [
        {
          title: "CI/CD Pipeline Implementation",
          description: "Jenkins, GitLab CI, GitHub Actions with automated build, test, and deployment workflows",
          icon: <GitBranch className="w-6 h-6" />,
          features: ["Jenkins/GitLab CI", "Automated Workflows", "Docker Containers", "IaC"],
          color: "#ea580c"
        },
        {
          title: "Cloud Architecture & Migration",
          description: "AWS, Azure, GCP solution design with lift-and-shift or refactor migrations",
          icon: <Cloud className="w-6 h-6" />,
          features: ["AWS/Azure/GCP", "Migration Strategy", "Cost Optimization", "Auto-scaling"],
          color: "#0369a1"
        },
        {
          title: "Containerization & Orchestration",
          description: "Docker containerization with Kubernetes cluster setup, management and Helm charts",
          icon: <Server className="w-6 h-6" />,
          features: ["Docker", "Kubernetes", "Helm Charts", "Best Practices"],
          color: "#7c3aed"
        },
        {
          title: "Monitoring & Logging",
          description: "Prometheus, Grafana dashboards with ELK/EFK logging stacks and alerting integration",
          icon: <BarChart3 className="w-6 h-6" />,
          features: ["Prometheus/Grafana", "ELK Stack", "Alerting", "Dashboards"],
          color: "#dc2626"
        },
        {
          title: "Security & Compliance",
          description: "Vulnerability scanning, secrets management and GDPR, HIPAA, SOC-2 advisory",
          icon: <Shield className="w-6 h-6" />,
          features: ["Vulnerability Scanning", "Secrets Management", "Compliance", "Security Advisory"],
          color: "#059669"
        }
      ]
    },
    {
      id: 4,
      title: "Quality Assurance",
      shortTitle: "QA Testing",
      icon: <TestTube className="w-5 h-5" />,
      color: "#ef4444",
      gradient: "from-red-500 to-pink-600",
      bgGradient: "from-red-50 to-pink-50",
      services: [
        {
          title: "Manual Testing Services",
          description: "Functional, regression, smoke testing with usability & exploratory testing expertise",
          icon: <Eye className="w-6 h-6" />,
          features: ["Functional Testing", "Regression Testing", "Usability Testing", "Test Design"],
          color: "#dc2626"
        },
        {
          title: "Automated Testing Frameworks",
          description: "Selenium WebDriver, Cypress, Playwright with API and mobile testing capabilities",
          icon: <Cpu className="w-6 h-6" />,
          features: ["Selenium/Cypress", "API Testing", "Mobile Testing", "Automated Frameworks"],
          color: "#7c3aed"
        },
        {
          title: "Performance & Load Testing",
          description: "JMeter, Gatling load scripts with stress testing and bottleneck analysis",
          icon: <TrendingUp className="w-6 h-6" />,
          features: ["JMeter/Gatling", "Load Testing", "Stress Testing", "Performance Analysis"],
          color: "#ea580c"
        },
        {
          title: "Security Testing (Penetration Testing)",
          description: "OWASP Top 10 assessment with network & application layer penetration tests",
          icon: <Shield className="w-6 h-6" />,
          features: ["OWASP Assessment", "Penetration Testing", "Security Analysis", "Remediation"],
          color: "#059669"
        },
        {
          title: "Test Management & Reporting",
          description: "TestRail, Zephyr setup with detailed QA dashboards and defect tracking workflows",
          icon: <FileText className="w-6 h-6" />,
          features: ["Test Management", "QA Dashboards", "Defect Tracking", "Reporting"],
          color: "#0891b2"
        }
      ]
    },
    {
      id: 5,
      title: "Data & Analytics",
      shortTitle: "Data Science",
      icon: <BarChart3 className="w-5 h-5" />,
      color: "#8b5cf6",
      gradient: "from-violet-500 to-purple-600",
      bgGradient: "from-violet-50 to-purple-50",
      services: [
        {
          title: "Data Strategy & Consulting",
          description: "Data maturity assessment with roadmap for data governance & technology stack recommendation",
          icon: <TrendingUp className="w-6 h-6" />,
          features: ["Maturity Assessment", "Data Governance", "Technology Stack", "Strategic Roadmap"],
          color: "#7c3aed"
        },
        {
          title: "Data Engineering & ETL",
          description: "Batch & real-time pipelines with data lake & warehouse design and API-driven ingestion",
          icon: <Database className="w-6 h-6" />,
          features: ["Airflow/Kafka", "Data Warehouse", "Real-time Pipelines", "API Integration"],
          color: "#0369a1"
        },
        {
          title: "Machine Learning & AI Solutions",
          description: "Predictive modeling, NLP solutions, and computer vision pipelines with latest frameworks",
          icon: <Brain className="w-6 h-6" />,
          features: ["ML Models", "NLP Solutions", "Computer Vision", "TensorFlow/PyTorch"],
          color: "#dc2626"
        },
        {
          title: "Business Intelligence & Reporting",
          description: "Dashboards with Power BI, Looker, Tableau and KPI definition with self-service analytics",
          icon: <BarChart3 className="w-6 h-6" />,
          features: ["Power BI/Tableau", "KPI Tracking", "Self-service Analytics", "Custom Dashboards"],
          color: "#ea580c"
        },
        {
          title: "MLOps & Model Deployment",
          description: "Model versioning & monitoring with containerized serving and data drift alerts",
          icon: <Settings className="w-6 h-6" />,
          features: ["MLflow/Seldon", "Model Monitoring", "Container Deployment", "Performance Alerts"],
          color: "#059669"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8 sm:py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
       
              

      <div
          className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
       >
  
                  <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 "  >
    Our{' '}
    <span
      className="bg-clip-text text-[#4F46E5] text-transparent text-4xl sm:text-5xl md:text-6xl"
      style={{
        background: 'linear-gradient(90deg, #4F46E5 0%, #8B5CF6 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}
    >
      Services
    </span>
  </h1>
  <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
    Comprehensive software development solutions tailored to drive innovation and accelerate your digital transformation journey.
  </p>
      </div>

        {/* Enhanced Category Navigation */}
        <div className="flex justify-center mb-8 sm:mb-16 px-2 sm:px-4">
          {/* Desktop View */}
          <div className="hidden lg:flex items-center space-x-2 bg-white/90 backdrop-blur-lg rounded-2xl p-2 shadow-xl ">
            {serviceCategories.map((category, index) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(index)}
                className={`group relative flex items-center px-6 py-4 rounded-xl font-semibold transition-all duration-500 transform hover:scale-105 min-w-0 ${
                  activeCategory === index
                    ? 'text-white shadow-xl scale-105'
                    : 'text-gray-700 hover:text-gray-900 hover:bg-white/70'
                }`}
                style={{
                  background: activeCategory === index 
                    ? `linear-gradient(135deg, ${category.color}, ${category.color}dd)` 
                    : 'transparent'
                }}
              >
                {/* Animated Background Glow */}
                {activeCategory === index && (
                  <div 
                    className="absolute inset-0 rounded-xl opacity-40 animate-pulse blur-sm"
                    style={{ background: `linear-gradient(135deg, ${category.color}, ${category.color}88)` }}
                  />
                )}
                
                {/* Icon Container */}
                <div className="relative mr-3 flex-shrink-0">
                  <div className={`transition-all duration-500 ${activeCategory === index ? 'scale-110 rotate-6' : 'scale-100'}`}>
                    {category.icon}
                  </div>
                </div>
                
                {/* Text */}
                <span className="relative z-10 text-sm font-medium whitespace-nowrap">{category.title}</span>
                
                {/* Floating Particles for Active Tab */}
                {activeCategory === index && (
                  <div className="absolute inset-0 pointer-events-none">
                    {[...Array(3)].map((_, i) => (
                      <div
                        key={i}
                        className="absolute w-1 h-1 rounded-full animate-ping"
                        style={{
                          backgroundColor: '#ffffff',
                          top: `${20 + i * 20}%`,
                          right: `${10 + i * 15}%`,
                          animationDelay: `${i * 200}ms`,
                          animationDuration: '2s'
                        }}
                      />
                    ))}
                  </div>
                )}
              </button>
            ))}
          </div>

          {/* Tablet View */}
          <div className="hidden md:flex lg:hidden items-center space-x-2 bg-white/90 backdrop-blur-lg rounded-2xl p-2 shadow-xl border border-white/30">
            {serviceCategories.map((category, index) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(index)}
                className={`group relative flex items-center px-4 py-3 rounded-xl font-semibold transition-all duration-500 transform hover:scale-105 min-w-0 ${
                  activeCategory === index
                    ? 'text-white shadow-xl scale-105'
                    : 'text-gray-700 hover:text-gray-900 hover:bg-white/70'
                }`}
                style={{
                  background: activeCategory === index 
                    ? `linear-gradient(135deg, ${category.color}, ${category.color}dd)` 
                    : 'transparent'
                }}
              >
                <div className="relative mr-2 flex-shrink-0">
                  <div className={`transition-all duration-500 ${activeCategory === index ? 'scale-110 rotate-6' : 'scale-100'}`}>
                    {category.icon}
                  </div>
                </div>
                <span className="relative z-10 text-xs font-medium whitespace-nowrap">{category.shortTitle}</span>
              </button>
            ))}
          </div>

          {/* Mobile View - Horizontal Scroll */}
          <div className="flex md:hidden w-full overflow-x-auto scrollbar-hide">
            <div className="flex items-center space-x-2 bg-white/90 backdrop-blur-lg rounded-2xl p-2 shadow-xl border border-white/30 min-w-max mx-2">
              {serviceCategories.map((category, index) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(index)}
                  className={`group relative flex flex-col items-center px-4 py-3 rounded-xl font-semibold transition-all duration-500 transform hover:scale-105 min-w-0 ${
                    activeCategory === index
                      ? 'text-white shadow-xl scale-105'
                      : 'text-gray-700 hover:text-gray-900 hover:bg-white/70'
                  }`}
                  style={{
                    background: activeCategory === index 
                      ? `linear-gradient(135deg, ${category.color}, ${category.color}dd)` 
                      : 'transparent',
                    minWidth: '70px'
                  }}
                >
                  <div className="relative mb-1 flex-shrink-0">
                    <div className={`transition-all duration-500 ${activeCategory === index ? 'scale-110 rotate-6' : 'scale-100'}`}>
                      {category.icon}
                    </div>
                  </div>
                  <span className="relative z-10 text-xs font-medium text-center leading-tight">{category.shortTitle}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Active Category Content */}
        <div className="mb-12 sm:mb-16">
          {serviceCategories.map((category, categoryIndex) => (
            <div
              key={category.id}
              className={`transition-all duration-700 ${
                activeCategory === categoryIndex
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-10 absolute pointer-events-none'
              }`}
            >
              {activeCategory === categoryIndex && (
                <>
                  {/* Category Header */}
                  <div className="text-center mb-8 sm:mb-12">
                    <div 
                      className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-2xl mb-4 sm:mb-6 shadow-lg"
                      style={{ backgroundColor: `${category.color}15`, color: category.color }}
                    >
                      <div className="scale-125 sm:scale-150">{category.icon}</div>
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">{category.title}</h2>
                    <div className="w-20 sm:w-24 h-1 rounded-full mx-auto" style={{ backgroundColor: category.color }}></div>
                  </div>

                  {/* Services Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                    {category.services.map((service, serviceIndex) => (
                      <div
                        key={serviceIndex}
                        className={`group relative bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100 overflow-hidden ${
                          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                        }`}
                        style={{ transitionDelay: `${serviceIndex * 100}ms` }}
                        onMouseEnter={() => setHoveredService(`${categoryIndex}-${serviceIndex}`)}
                        onMouseLeave={() => setHoveredService(null)}
                      >
                        {/* Animated Background */}
                        <div 
                          className={`absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500 bg-gradient-to-br`}
                          style={{ background: `linear-gradient(135deg, ${service.color}22, ${service.color}11)` }}
                        ></div>
                        
                        {/* Glowing Border */}
                        <div 
                          className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"
                          style={{ boxShadow: `0 0 30px ${service.color}25` }}
                        ></div>

                        {/* Content */}
                        <div className="relative z-10">
                          {/* Service Icon */}
                          <div 
                            className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-xl mb-4 sm:mb-6 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3"
                            style={{ backgroundColor: `${service.color}15`, color: service.color }}
                          >
                            {service.icon}
                          </div>

                          {/* Service Title */}
                          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-gray-900 group-hover:to-gray-700 group-hover:bg-clip-text transition-all duration-300">
                            {service.title}
                          </h3>

                          {/* Service Description */}
                          <p className="text-gray-600 text-sm mb-4 sm:mb-6 leading-relaxed">
                            {service.description}
                          </p>

                          {/* Features */}
                          <div className="space-y-2 mb-4 sm:mb-6">
                            {service.features.map((feature, featureIndex) => (
                              <div 
                                key={featureIndex}
                                className={`flex items-center text-xs text-gray-500 transition-all duration-500 ${
                                  hoveredService === `${categoryIndex}-${serviceIndex}` ? 'text-gray-700 translate-x-2' : ''
                                }`}
                                style={{ transitionDelay: `${featureIndex * 50}ms` }}
                              >
                                <div 
                                  className="w-1.5 h-1.5 rounded-full mr-3 transition-all duration-300 flex-shrink-0"
                                  style={{ 
                                    backgroundColor: hoveredService === `${categoryIndex}-${serviceIndex}` ? service.color : '#9ca3af'
                                  }}
                                ></div>
                                {feature}
                              </div>
                            ))}
                          </div>

                          {/* Learn More Button */}
                          <div className={`transition-all duration-500 ${
                            hoveredService === `${categoryIndex}-${serviceIndex}` ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                          }`}>
                            <button 
                              className="flex items-center justify-between w-full py-3 px-4 rounded-lg text-white text-sm font-medium transition-all duration-300 hover:shadow-lg group"
                              style={{ backgroundColor: service.color }}
                            >
                              <span>Learn More</span>
                              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                            </button>
                          </div>
                        </div>

                        {/* Floating Elements */}
                        {hoveredService === `${categoryIndex}-${serviceIndex}` && (
                          <div className="absolute inset-0 pointer-events-none overflow-hidden">
                            {[...Array(4)].map((_, i) => (
                              <div
                                key={i}
                                className="absolute w-2 h-2 rounded-full animate-ping"
                                style={{
                                  backgroundColor: service.color,
                                  top: `${15 + i * 20}%`,
                                  right: `${5 + i * 10}%`,
                                  animationDelay: `${i * 300}ms`,
                                  animationDuration: '3s',
                                  opacity: 0.6
                                }}
                              ></div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        {/* Call to Action */}
       
              
              <div
  className={`text-center rounded-2xl sm:rounded-3xl p-8 sm:p-12 transition-all duration-1000 delay-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
  style={{
    background: 'linear-gradient(90deg, #6366F1 0%, #8B5CF6 100%)',
    color: '#fff'
  }}
>
  <h2
    className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6"
    style={{ color: '#fff' }}
  >
    Ready to Start Your Project?
  </h2>
  <p
    className="text-lg sm:text-xl mb-6 sm:mb-8 max-w-2xl mx-auto"
    style={{ color: '#E0E7FF' }} // Tailwind's indigo-100
  >
    Let's collaborate to bring your vision to life with cutting-edge technology and expert development.
  </p>
  <div className="flex flex-col sm:flex-row gap-4 justify-center">
    <button
      className="px-6 sm:px-8 py-3 sm:py-4 font-semibold rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300"
      style={{
        background: '#fff',
        color: '#6366F1' // Tailwind's indigo-600
      }}
    >
      Get Free Consultation
    </button>
    <button
      className="px-6 sm:px-8 py-3 sm:py-4 border-2 font-semibold rounded-full hover:bg-white transition-all duration-300"
      style={{
        borderColor: '#fff',
        color: '#fff'
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = '#fff';
        e.currentTarget.style.color = '#6366F1';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.color = '#fff';
      }}
    >
      View Our Portfolio
    </button>
  </div>
</div>
      </div>

      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default ServicesComponent;